// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

// Services
import { Api } from "#/api";

// Interfaces
import { Person } from "#/common/interfaces/Person";

import { Headline } from "#/components/headline/Headline";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class ContactModule extends ModuleBase {
  public contacts: Array<any> = [];

  public constructor() {
    super();

    if (this.instance.hasOwnProperty("contacts")) {
      this.getContacts();
    }
  }

  public async getContacts() {
    let contactsArr: Array<any> = [];

    let contactIds: Array<number> = [];
    for (let i = 0; i < this.instance["contacts"].length; i++) {
      let contact = this.instance["contacts"][i]["contact"];
      contactIds.push(contact["contact_id"]);
    }

    let persons = await Api.personService.getPerson(contactIds);
    for (let i = 0; i < persons.length; i++) {
      let person = persons[i];

      let personThema = "";
      let contact = this.instance["contacts"][i]["contact"];
      if (contact["contact_id"] === person["id"]) {
        personThema = contact["thema"];
      }

      let obj = Object.assign({ thema: personThema }, person);
      contactsArr.push(obj);
    }

    this.contacts = contactsArr;
  }

  get getHeadlineSize() {
    switch (this.instance["headline"]["type"]) {
      case "h1":
        return 1;
      case "h2":
        return 2;
      case "h3":
        return 3;
      case "subline":
        return 4;
      default:
        return 1;
    }
  }

  get getHeadlineLine() {
    let color = this.instance["background"];
    return color !== "black";
  }

  get getHeadlineTheme() {
    let color = this.instance["background"];
    return color == "black" ? "secondary" : "default";
  }

  public getBackgroundColorFromInstance(instance: object) {
    return this.instance.hasOwnProperty("background")
      ? this.instance["background"]
      : "black";
  }

  public get gridWidthLg() {
    if (this.contacts.length == 1) {
      return 12;
    } else if (this.contacts.length == 2) {
      return 6;
    } else {
      return 4;
    }
  }

  public get gridWidthMd() {
    if (this.contacts.length == 1) {
      return 12;
    } else {
      return 6;
    }
  }
}
